/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, Text, ColorPicker, Modal } from '../uiold';

import { WHITE_RGB_COLOR } from '../uiold/Constants';
import { Account, RGBColor, Settings } from '../../types/shared/Account';
import { Season } from '../../types/shared/Season';

import AccountActions from '../../support/AccountActions';
import { postJSON } from '../../support/Fetch';
import { showSuccess } from '../App/AppAlert';

type Props = {
  onHide: () => void;
  isModalVisible: boolean;
  account: Account | undefined;
  season?: Season | undefined;
};

export default function MapOptionsDialog(props: Props) {
  let { onHide, isModalVisible, account } = props;

  let [backgroundColor, setBackgroundColor] = useState<RGBColor>(
    account?.settings?.maps?.backgroundColor ?? WHITE_RGB_COLOR,
  );
  let onBackgroundColorChange = (color: RGBColor) => {
    setBackgroundColor(color);
  };

  if (!account) {
    return null;
  }

  let onSave = () => {
    if (account) {
      let oldSettings = account?.settings;
      let newSettings: Settings = {
        ...oldSettings,
        maps: {
          backgroundColor,
        },
      };
      AccountActions.updateAccount({ settings: newSettings });
      // We don't need to send the seasonID here since settings do not get
      // archived when we archive a season. I guess this is an implementation
      // detail on the backend so it might make sense to send the seasonID to
      // the backend anyway, but I believe that can be determined from the
      // headers, so now that I think about it we don't need to send accountID
      // here at all. But I'll leave this alone for now.
      postJSON(`/api/accounts/${account.id}/embedSettings`, newSettings);
      showSuccess('Map settings saved.');
      onHide();
    }
  };

  return (
    <Modal isVisible={isModalVisible} onClose={onHide} scrollBehavior="outside">
      <Modal.Header title="Map Embed Options" />
      <Modal.Body>
        <View style={styles.modalContent}>
          <Text style={styles.colorLabel}>Background Color</Text>
          <ColorPicker
            selectedColor={backgroundColor}
            handleChange={onBackgroundColorChange}
          />
        </View>
      </Modal.Body>

      <Modal.Footer>
        <Button title="Cancel" onPress={onHide} />
        <Button title="Save" onPress={onSave} isPrimary />
      </Modal.Footer>
    </Modal>
  );
}

let styles = StyleSheet.create({
  modalContent: {
    flexDirection: 'row',
    flex: 1,
  },
  colorLabel: {
    marginRight: 20,
  },
});
